import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { PieChart } from "lucide-react";
import { StatusBreakdown } from "@/hooks/useDepletionMonthly";
import { getStatusColor } from "./statusColors";
import { cn } from "@/lib/utils";

interface Props {
  statusBreakdown: StatusBreakdown[];
  total: number;
  isLoading: boolean;
}

export function DepletionV2CrmCard({ statusBreakdown, total, isLoading }: Props) {
  if (isLoading) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-base">
            <PieChart className="h-4 w-4" />
            สถานะการติดตาม
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </CardContent>
      </Card>
    );
  }

  if (total === 0) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-base">
            <PieChart className="h-4 w-4" />
            สถานะการติดตาม
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">ไม่มีข้อมูล</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <PieChart className="h-4 w-4" />
          สถานะการติดตาม ({total} คน)
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {statusBreakdown.map((item) => (
          <div key={item.status} className="flex items-center justify-between gap-2 p-2 rounded-md bg-muted/50">
            <Badge className={cn("border font-normal", getStatusColor(item.status))}>
              {item.status}
            </Badge>
            <span className="text-sm font-medium">
              {item.count} คน ({item.percent}%)
            </span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
